const TimeStamp = Date.now();
const locationReplace = (url) => {
  if (history.replaceState) {
    history.replaceState(null, document.title, url);
    history.go(0);
  } else {
    location.replace(url);
  }
};
const removeParamFromSearch = (paramKey) => {
  const searchParams = new URLSearchParams(location.search);
  searchParams.delete(paramKey);
  let newUrl = location.pathname + "?" + searchParams.toString();
  if (searchParams.toString() === "") {
    newUrl = location.pathname;
  }
  history.replaceState(null, "", newUrl);
};

window.getAlchemyPayRampVersion = (version) => {
  if (localStorage.getItem("AlchemyPayRampVersion") !== version) {
    localStorage.setItem("AlchemyPayRampVersion", version); // 保存 以便下次使用判断
    let urlObj = new URL(location.href);
    if (urlObj.search) {
      urlObj.search += `&AlchemyPayRampTimeStamp=${TimeStamp}`;
    } else {
      urlObj.search = `AlchemyPayRampTimeStamp=${TimeStamp}`;
    }
    locationReplace(urlObj.toString());
  } else {
    removeParamFromSearch("AlchemyPayRampTimeStamp");
  }
};
(function () {
  let versionScript = document.createElement("script");
  versionScript.src = "./AlchemyPayRampVersion.js?v=" + TimeStamp;
  let s = document.querySelector("script");
  s.parentNode.insertBefore(versionScript, s);
})();
